<template>
  <page-loader v-if="loadingStatus == 'loading'" />
  <div v-else class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="archaic-upgrade-container-fluid">
            <!-- BreadCrumb component starts here -->

            <nav class="mt-4" style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
              <ol class="breadcrumb blood-test-breadcrumb">
                <li class="breadcrumb-item" aria-current="page">
                  <router-link :to="{ name: 'dashboard' }">Home</router-link>
                </li>
                <li class="breadcrumb-item" aria-current="page">
                  <router-link :to="{ name: 'bloodTest' }">Blood Test</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'bloodTest' }">{{
                    test?.name
                  }}</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  <router-link :to="{ name: 'bloodTest' }">General Details</router-link>
                </li>
              </ol>
            </nav>
            <div class="prev-button is-mobile">
              <router-link :to="{ name: 'bloodTest' }">
                <img src="@/assets/images/back-arrow.svg" />
                <span>Back</span>
              </router-link>
            </div>
            <!-- <a href="javascript:void(0);" class="back-button" @click="goBack">
              <span class="back-arrow">&larr;</span> Back
            </a> -->
            <!-- BreadCrumb Component ends here -->

            <!-- 70 30 Col component starts here -->
            <div class="report-wrapper-row">
              <div class="row">
                <div class="col-lg-3">
                  <BloodTestPanel :selectedBloodTest="selectedBloodTest" @selectPanel="handlePanelSelection" />
                </div>
                <div class="col-lg-9">
                  <div id="report-wrapper-row" class="report-right-row">
                    <h2>
                      {{ patientStore.patient.firstName }}, your blood test
                      result
                    </h2>

                    <div class="order-next-test-row">
                      <div>
                        <h4>Test due: {{ patientStore.nextBloodTest.name }}</h4>
                        <p>
                          Due Date :
                          {{
                            patientStore.nextBloodTest.dueDate.toLocaleDateString(
                              "en-GB"
                            )
                          }}
                        </p>
                      </div>
                      <div>
                        <button>Order next test</button>
                      </div>
                    </div>

                    <!-- function and effieciency component starts here -->
                    <div class="function-efficiency-row">
                      <div class="efficiency-grid-row">
                        <div class="heading-reports">
                          <div>
                            <p>{{ test?.name }}</p>
                          </div>
                          <div class="light-green bg-light-green">
                            <p>{{ instance }} test</p>
                          </div>
                        </div>
                        <div>
                          <p>
                            Active
                            {{
                              new Date(test.result.date).toLocaleDateString(
                                "en-GB"
                              )
                            }}
                          </p>
                        </div>
                      </div>

                      <p v-html="test.result.medicalReport"></p>

                      <div class="signature-row-group" v-if="doctor?.name">
                          <img class="signature-profile" :src="doctor?.photos[0].url" alt="" height="144" width="144"/>
                        <div class="signature-row-dis">
                          <img class="signature-img" :src="doctor?.signature[0].url" alt="" width="122" height="32" />
                          <h3>{{ doctor?.name }}</h3>
                          <p>{{ doctor?.biography }}</p>
                        </div>
                      </div>

                      <!-- Book consultation component starts here -->
                      <div class="book-consultation-row justify-content-between align-items-center">
                        <HealthTrafficLights v-if="!test.result.testFailed" :bloodTest="test.result"
                          v-slot="{ inRange, outOfRange }">
                          <div class="points d-flex gap-3">
                            <div class="d-flex justify-content-center align-items-center gap-2">
                              <div class="count-out-of-range">{{ outOfRange }}x</div>

                              <span>out of range</span>
                            </div>
                            <div class="d-flex justify-content-center align-items-center gap-2">
                              <div class="count-in-range">{{ inRange }}x</div>
                              <span> normal range</span>
                            </div>
                          </div>
                        </HealthTrafficLights>
                        <div>
                          <button @click="goToConsultation">
                            Book A Consultation
                          </button>
                        </div>
                      </div>
                      <!-- Book consultation component ends here -->

                      <div v-if="headerText" class="mt-4" v-html="headerText.body" />

                    </div>
                    <!-- function and effieciency component ends here -->
                  </div>
                </div>
              </div>
            </div>
            <!-- 70 30 col component ends here -->
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import Header from "@/components/header/Header.vue";
import "../../../styles/pages/FunctionEfficiency.scss";
/* import UserIcon from "../../../assets/images/Health/user_icons.png";
import UserSignature from "../../../assets/images/Health/signature.png"; */
import { usePatientStore } from "@/store/health/blood";
import { useRouter, useRoute } from "vue-router";
// import BookConsultation from "./BookConsultation.vue";
import HealthTrafficLights from "@/components/HealthTrafficLights.vue";
import BloodTestPanel from "./BloodTestPanel.vue";
import { getHeaderText, getDoctorDetails } from "@/services/price.js";
import { useLoading } from "@/composables/useLoading";
import { nextTick, ref, onMounted } from "vue";

const router = useRouter();
const route = useRoute();
const patientStore = usePatientStore();

const headerText = ref({});
const doctor = ref({});
const { loadingStatus, finishLoading } = useLoading();

const selectedBloodTest = patientStore.getTestByBarcode(route.params.barcode);
const instance = selectedBloodTest.instance;
const selectedPanelName = ref("");
const test = selectedBloodTest;

// Use onMounted for better lifecycle management
onMounted(async () => {
  try {
    const [headerResponse, doctorResponse] = await Promise.all([
      getHeaderText(),
      getDoctorDetails(test?.result?.doctor?.name)
    ]);

    headerText.value = headerResponse.data.data.HeaderText;
    doctor.value = doctorResponse.data.data.Authors.items[0];

    finishLoading();
  } catch (error) {
    console.error("Error fetching data:", error);
    finishLoading(); // Ensure loading finishes even on error
  }
});

const handlePanelSelection = async (panelName, barcode) => {
  selectedPanelName.value = panelName;

  try {
    await router.push(`/kidney/electrolytes/${barcode}/${panelName}`);
    await nextTick();

    const section = document.getElementById("report-wrapper-row");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  } catch (error) {
    console.error("Navigation error:", error);
  }
};

function goToConsultation() {
  router.push({ name: "bookConsultation" });
}
</script>
